import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { PatientDialogComponent } from 'src/app/components/patient-dialog/patient-dialog.component';
import { tPatientModel } from 'src/app/models/tPatientModel';
import { tModuleModel } from 'src/app/models/tModuleModel';
import { NewPatientDialogComponent } from 'src/app/components/patient-dialog/new-patient-dialog/new-patient-dialog.component';

var TAG = "NewPatientDialogService";

@Injectable({
    providedIn: 'root'
})
export class NewPatientDialogService {

    static ACTION_OPEN = "open";

    constructor(private log: LoggerService,
        private modalService: NgbModal
    ) {

    }

    openDialog() {
        // console.log('open Dialog');
        this.log.d(TAG, 'open Dialog ');
        const modalRef = this.modalService.open(NewPatientDialogComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard:false });


        return modalRef;

    }





}
